import { render } from "./TheLanguagesContainer.vue?vue&type=template&id=a4f2ccea"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__